var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifyWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.99996V12M12 16H12.01M10.29 2.85996L1.82002 17C1.64539 17.3024 1.55299 17.6453 1.55201 17.9945C1.55103 18.3437 1.64151 18.6871 1.81445 18.9905C1.98738 19.2939 2.23675 19.5467 2.53773 19.7238C2.83871 19.9009 3.18082 19.9961 3.53002 20H20.47C20.8192 19.9961 21.1613 19.9009 21.4623 19.7238C21.7633 19.5467 22.0127 19.2939 22.1856 18.9905C22.3585 18.6871 22.449 18.3437 22.448 17.9945C22.4471 17.6453 22.3547 17.3024 22.18 17L13.71 2.85996C13.5318 2.56607 13.2807 2.32308 12.9812 2.15444C12.6817 1.98581 12.3438 1.89722 12 1.89722C11.6563 1.89722 11.3184 1.98581 11.0188 2.15444C10.7193 2.32308 10.4683 2.56607 10.29 2.85996Z",
    stroke: "#F2C94C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyWarning);
export default __webpack_public_path__ + "static/media/notify_warning.a3b616b2.svg";
export { ForwardRef as ReactComponent };